module.exports = __webpack_public_path__ + "static/media/WISB.3d48aa22.png";